import * as Color from "../Color";
import { IconColor } from "./IconColor";
import { getColorFromIconColor } from "./getColorFromIconColor";

/**
 * Maps icon color names to CSS variable references with fallback values.
 *
 * Fallback hex values match the legacy `getColorFromIconColor` palette so that
 * an unstyled token render is visually identical to legacy mode.
 */
const iconColorTokenMap: Record<IconColor, string> = {
  black: "var(--icon-color-black, #000)",
  body: "var(--icon-color-body, #3e5d6f)",
  white: "var(--icon-color-white, #fff)",
  darkblue: "var(--icon-color-darkblue, var(--color-palette-darkblue-500, #1e4488))",
  turquoise: "var(--icon-color-turquoise, #0071b3)",
  lightgrey: "var(--icon-color-lightgrey, #aebfcc)",
  red: "var(--icon-color-red, #ce202f)",
  green: "var(--icon-color-green, #4aa486)",
  orange: "var(--icon-color-orange, #f47e48)",
  darkgreen: "var(--icon-color-darkgreen, #1e5d4a)",
  darkgrey: "var(--icon-color-darkgrey, #3e5d6f)",
  purple: "var(--icon-color-purple, #5e6db3)",
};

/**
 * Gets a CSS value string for the given icon color, appropriate for the current style mode.
 * @param color The icon color (named string or RgbColor object).
 * @param isTokenMode Whether the component is running in token mode.
 * @returns A CSS value string (CSS variable reference in token mode, rgba in legacy mode).
 */
export function getIconColorCssValue(color: IconColor | Color.RgbColor, isTokenMode: boolean): string {
  if (typeof color !== "string") {
    return Color.toString(color);
  }

  if (isTokenMode) {
    return iconColorTokenMap[color];
  }

  return Color.toString(getColorFromIconColor(color));
}
